module.exports = __webpack_public_path__ + "static/media/me-eyes-looking-left.d87dbca0.svg";